export default {
  user: {
    label: 'Usuário',
    description: 'Usuário padrão do tenant.'
  },
  editor: {
    label: 'Editor',
    description: 'Perfil especializado, independente de user/admin.'
  },
  admin: {
    label: 'Administrador',
    description: 'Administrador funcional do tenant.'
  },
  sys_bot: {
    label: 'Bot do Sistema',
    description: 'Conta técnica interna da plataforma.'
  },
  api: {
    label: 'Integração / API',
    description: 'Conta não humana usada por integrações.'
  }
};
